import {
  LIBRARY_TAXES_PAGE_REQUEST,
  LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS,
  LIBRARY_TAXES_LIST_REQUEST,
  LIBRARY_TAXES_ON_CLICK_ROW,
  LIBRARY_TAXES_ON_CLICK_CANCEL,
  LIBRARY_TAXES_SUBMIT_FORM_UPDATE,
  LIBRARY_TAXES_SUBMIT_FORM_CREATE,
  LIBRARY_TAXES_ON_CLICK_CREATE_TAX,
  LIBRARY_TAXES_DELETE_TAX_REQUEST,
  LIBRARY_TAXES_CANCEL_DELETE,
  LIBRARY_TAXES_DELETE_TAX,
  LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS,
} from 'actions/library/tax/constants';
import { takeLatest, put, call, takeEvery, select } from 'redux-saga/effects';
import { initialize, change } from 'redux-form';
import * as act from 'actions';
import * as actNotif from 'actions/notifications';
import * as actTax from 'actions/library/tax';
import * as apiOutlets from 'api/outlets';
import * as apiProfile from 'api/profile';
import * as apiTax from 'api/taxes';
import { setSelectedOutletIds } from 'actions/actionBar';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import * as clevertapLibraryTax from 'clevertap/library/tax';
import * as _ from 'lodash';
import { getSelectedOutlet } from 'utils/userProperties';
import * as actOutletList from 'actions/outletPages/list';

const getCloneNotification = state =>
  state.outletPages.list.showCloneOutletNotification.notification;

function* fillSearchFormFromProfile(profile) {
  let assignedOutletIds = [];
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]];
  } else {
    assignedOutletIds = profile.outlet_id;
  }
  const data = { outletIds: assignedOutletIds };
  yield put(initialize('search', data));
}

function* fillFormTaxDetail(tax) {
  const formTaxDetail = {
    id: tax.id,
    name: tax.name,
    amount: tax.amount ? tax.amount.toString() : tax.amount,
  };
  yield put(initialize('tax', formTaxDetail));
}

function* openRightColumn() {
  yield put(actTax.openRightColumn());
}

function* closeRightColumn() {
  yield put(actTax.closeRightColumn());
}

function* getCloneOutletNotification() {
  const notification = yield select(getCloneNotification);
  return notification;
}

export function* taxesPageRequestFlow() {
  // reset
  yield put(actTax.setListTaxes([]));
  yield put(showPageLoadingSpinner(true));
  yield put(actTax.setTaxDetail(null));
  yield put(actTax.setOutlets([]));
  yield call(closeRightColumn);

  yield put(act.showProgressBar());
  try {
    const response = yield call(apiOutlets.outlets);
    yield put(actTax.setOutlets(response.data));

    const resProfile = yield call(apiProfile.getProfile);
    clevertapLibraryTax.libraryTaxStart({
      currOutlet: resProfile.data.outlet_id[0],
    });

    yield call(fillSearchFormFromProfile, resProfile.data);

    const resTaxes = yield call(apiTax.getTaxes, { page: 1 });
    const taxes = resTaxes.data.results;
    yield put(actTax.setListTaxes(taxes));
    yield put(actTax.setTotalPage(resTaxes.data.total_pages));
    yield put(actTax.setCurrentPage(1));
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* taxesRequestFlow(action) {
  const {
    payload: { params, previousTaxes },
  } = action;
  yield put(act.showProgressBar());

  try {
    const response = yield call(apiTax.getTaxes, params);
    const taxes = previousTaxes.concat(response.data.results);
    yield put(actTax.setListTaxes(taxes));
    yield put(actTax.setTotalPage(response.data.total_pages));
    yield put(actTax.setCurrentPage(params.page));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* onChangeOutletIds(action) {
  yield put(actTax.setListTaxes([]));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { outletIds },
  } = action;
  const previousOutlet = yield select(getSelectedOutlet);

  clevertapLibraryTax.libraryChangeOutlet({
    previousOutlet,
    currOutlet: outletIds,
  });
  try {
    yield put(actTax.setTaxDetail(null));
    yield call(closeRightColumn);
    yield call(fillFormTaxDetail, { id: null, name: null, amount: null });
    yield put(act.showProgressBar());
    yield put(setSelectedOutletIds(outletIds));
    yield put(change('search', 'outletIds', outletIds));
    yield call(apiOutlets.patchLogin, { id: outletIds });
    const res = yield call(apiTax.getTaxes, { page: 1 });
    yield put(actTax.setListTaxes(res.data.results));
    yield put(actTax.setTotalPage(res.data.total_pages));
    yield put(actTax.setCurrentPage(1));
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* onClickRowFlow(request) {
  const {
    payload: { tax },
  } = request;
  try {
    yield put(act.showProgressBar());
    const taxDetail = yield call(apiTax.getTaxDetail, tax.id, tax.name);
    yield put(actTax.setTaxDetail(taxDetail.data));

    yield call(fillFormTaxDetail, taxDetail.data);
    yield call(openRightColumn);
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onClickCancelFlow() {
  yield put(actTax.setTaxDetail(null));
  yield call(fillFormTaxDetail, { id: null, name: null, amount: null });
  yield call(closeRightColumn);
}

export function* updateTaxFlow(request) {
  const {
    payload: { id, data, previousTaxes },
  } = request;
  yield put(act.showProgressBar());
  yield put(actTax.isSubmittingForm(true));
  try {
    const response = yield call(apiTax.updateTax, id, data);
    const taxData = response.data;
    const taxes = [];
    previousTaxes.forEach(tax => {
      if (tax.id === id) {
        taxes.push(taxData);
      } else {
        taxes.push(tax);
      }
    });
    yield put(
      actNotif.success(
        'Taxes successfully saved.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actTax.setListTaxes(taxes));
    yield put(actTax.setTaxDetail(taxData));
    yield call(fillFormTaxDetail, taxData);
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actTax.isSubmittingForm(false));
  }
}

export function* onClickCreateTaxFlow() {
  yield put(actTax.setTaxDetail(null));
  yield call(fillFormTaxDetail, { id: null, name: null, amount: null });
  yield call(openRightColumn);
}

export function* createTaxFlow(request) {
  const {
    payload: { data, previousTaxes },
  } = request;
  yield put(act.showProgressBar());
  yield put(actTax.isSubmittingForm(true));
  try {
    const response = yield call(apiTax.createTax, data);
    const taxData = response.data;
    const taxes = [taxData];
    previousTaxes.forEach(tax => {
      taxes.push(tax);
    });
    yield put(
      actNotif.success(
        'Taxes successfully created.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actTax.setListTaxes(taxes));
    yield put(actTax.setTaxDetail(taxData));
    yield call(fillFormTaxDetail, taxData);
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actTax.isSubmittingForm(false));
  }
}

export function* deleteTaxRequest(request) {
  const {
    payload: { deletedTax },
  } = request;
  yield put(actTax.setDeletedTax(deletedTax));
  yield put(actTax.showDeleteModal());
}

export function* deleteTaxFlow(request) {
  const {
    payload: { id, previousTaxes },
  } = request;
  yield put(act.showProgressBar());
  _.forEach(previousTaxes, prevTax => {
    if (id === prevTax.id)
      clevertapLibraryTax.libraryDeleteTax({ tax: prevTax });
  });
  try {
    yield call(apiTax.deleteTax, id, previousTaxes.name);
    const taxes = [];
    previousTaxes.forEach(tax => {
      if (tax.id !== id) {
        taxes.push(tax);
      }
    });
    yield put(actTax.setListTaxes(taxes));
    yield put(actTax.setTaxDetail(null));
    yield put(actTax.setDeletedTax(null));
    yield put(actTax.hideDeleteModal());
    yield call(closeRightColumn);
    yield put(
      actNotif.success(
        'Taxes successfully deleted.',
        yield getCloneOutletNotification()
      )
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* cancelDeleteTaxFlow() {
  yield put(actTax.setDeletedTax(null));
  yield put(actTax.hideDeleteModal());
}

export function* createTaxAllOutletsFlow(request) {
  const {
    payload: { data, previousTaxes },
  } = request;
  yield put(act.showProgressBar());
  yield put(actTax.isSubmittingForm(true));
  try {
    const response = yield call(apiTax.createTaxAllOutlets, data);
    const taxData = response.data;
    const taxes = [taxData];
    previousTaxes.forEach(tax => {
      taxes.push(tax);
    });
    yield put(
      actNotif.success(
        'Taxes successfully created.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actTax.setListTaxes(taxes));
    yield put(actTax.setTaxDetail(taxData));
    yield call(fillFormTaxDetail, taxData);
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actTax.isSubmittingForm(false));
  }
}

export default function* saga() {
  yield takeLatest(LIBRARY_TAXES_PAGE_REQUEST, taxesPageRequestFlow);
  yield takeEvery(LIBRARY_TAXES_LIST_REQUEST, taxesRequestFlow);
  yield takeLatest(LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);
  yield takeLatest(LIBRARY_TAXES_ON_CLICK_ROW, onClickRowFlow);
  yield takeLatest(LIBRARY_TAXES_ON_CLICK_CANCEL, onClickCancelFlow);
  yield takeLatest(LIBRARY_TAXES_SUBMIT_FORM_UPDATE, updateTaxFlow);
  yield takeLatest(LIBRARY_TAXES_ON_CLICK_CREATE_TAX, onClickCreateTaxFlow);
  yield takeLatest(LIBRARY_TAXES_SUBMIT_FORM_CREATE, createTaxFlow);
  yield takeLatest(LIBRARY_TAXES_DELETE_TAX_REQUEST, deleteTaxRequest);
  yield takeLatest(LIBRARY_TAXES_DELETE_TAX, deleteTaxFlow);
  yield takeLatest(LIBRARY_TAXES_CANCEL_DELETE, cancelDeleteTaxFlow);
  yield takeLatest(
    LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS,
    createTaxAllOutletsFlow
  );
}
